export const PAGE_SAVE_HISTORY_AND_PARAMS = "@PAGE/SAVE_HISTORY_AND_PARAMS";
export const PAGE_NAVIGATE_TO = "@PAGE/NAVIGATE_TO";
export const PAGE_OPEN_GENERIC_ERROR_MODAL = "@PAGE/OPEN_GENERIC_ERROR_MODAL";
export const PAGE_CLOSE_GENERIC_ERROR_MODAL = "@PAGE/CLOSE_GENERIC_ERROR_MODAL";
export const PAGE_SET_CHANNELS = "@PAGE/SET_CHANNELS";
export const PAGE_VALIDATE_CHANNELS = "@PAGE/VALIDATE_CHANNELS";
export const PAGE_SET_DISTRIBUTION_CODE = "@PAGE/PAGE_SET_DISTRIBUTION_CODE";
export const PAGE_SET_IS_STARTED_FLOW = "@PAGE/SET_IS_STARTED_FLOW";
